import { ThemeUICSSObject } from 'theme-ui';
import { overlay } from './overlay';
import { spacing, responsive } from '../../../../util';
import getColorsByPath from '../../../colors/util/getColorsByPath';
import { apiaApi } from './apiaApi';
import confirm from './confirm';
import table from './table';
import tableModal from './tableModal';
import buttonsBar from './buttonsBar';
import apiaFinder from './apiaFinder';
import deadSession from './deadSession';
/* IMPORT HERE */
export const modals: ThemeUICSSObject = {
  apiaApi,
  buttonsBar,
  confirm,
  deadSession,
  ...overlay,
  table,
  tableModal,
  apiaFinder,

  main: {
    boxShadow: 'modals',
    borderRadius: 'modals',
    zIndex: 'modal',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyItems: 'center',
    maxHeight: '100vh',
    maxWidth: 'calc(100vw - 10px)',
    resize: 'both',
    overflow: 'auto',
    border: '1px solid',
    gap: '0px !important',

    'div.modal__header': {
      alignItems: responsive({ 0: 'end', 4: 'center' }),
      flexShrink: 0,
      overflow: 'visible',
      p: '16px 20px',

      borderBottom: '1px solid lightgray',

      '.modal__headerBar': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
    },
    'div.modal__content': {
      overflow: 'auto',
      width: '100%',
      flexBasis: '100%',
      flexDirection: 'column',
      flexShrink: 1,
      display: 'flex',
      justifyContent: 'stretch',
      alignItems: 'stretch',
      p: '20px',
    },
    'div.modal__content>form': {
      overflow: 'auto',
      width: '100%',
      flexBasis: '100%',
      flexShrink: 1,
      display: 'flex',
      justifyContent: 'stretch',
      alignItems: 'stretch',
    },
    ...getColorsByPath('modal'),
  },

  finder: {
    variant: 'layout.common.modals.main',
    height: responsive({ 0: '100vh', 3: '80vh' }),
    width: responsive({ 0: '95vw', 3: '80vw', 4: '70vw' }),

    '.modal__content': {
      overflow: 'hidden',

      '.confirm__content': {
        overflow: 'hidden',

        '.finder__content': {
          display: 'flex',
          alignItems: 'stretch',
        },

        '.selection__keyHandler': {
          overflow: 'hidden',
          height: '100%',

          '.responsiveTable__wrapper': {
            height: '100%',

            border: '1px solid',
            borderColor: 'palette.border.article',
            backgroundColor: 'palette.background.default',
          },
        },
      },

      '.table_container': {
        flexGrow: 1,
      },

      '.pagination': {
        position: 'sticky',
        bottom: '0',
      },
    },

    '.responsiveTableContext__wrapper': {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',

      '.responsiveTable__wrapper': {
        height: '100%',
      },

      '& > *:first-child': {
        height: '100%',
      },
    },
  },
  sm: {
    variant: 'layout.common.modals.main',
    maxWidth: 'min(350px, calc(100vw - 10px))',
  },
  md: {
    variant: 'layout.common.modals.main',
    maxWidth: 'min(500px, calc(100vw - 10px))',
  },
  'md-fixed': {
    variant: 'layout.common.modals.main',
    width: 'min(500px, calc(100vw - 10px))',
    maxHeight: responsive({ 0: '95vh', 2: '80vh' }),
  },
  lg: {
    variant: 'layout.common.modals.main',
    maxWidth: 'min(640px, calc(100vw - 10px))',
  },
  'lg-fixed': {
    variant: 'layout.common.modals.main',
    width: '640px',
    height: '60vh',
  },
  xl: {
    variant: 'layout.common.modals.main',
    width: responsive({ 0: '95vw', 2: '60vw' }),
    height: responsive({ 0: '95vh', 2: '80vh' }),
  },
  'xl-fixed': {
    variant: 'layout.common.modals.main',
    width: responsive({ 0: '95vw', 2: '60vw' }),
    height: responsive({ 0: '95vh', 2: '80vh' }),
  },
  xxl: {
    variant: 'layout.common.modals.main',
    width: responsive({ 0: '95vw', 2: '80vw' }),
    maxHeight: responsive({ 0: '95vh', 2: '80vh' }),
  },
  'xxl-fixed': {
    variant: 'layout.common.modals.main',
    width: responsive({ 0: '95vw', 2: '80vw' }),
    height: responsive({ 0: '95vh', 2: '80vh' }),
  },
  xxxl: {
    variant: 'layout.common.modals.main',
    width: responsive({ 0: '95vw', 2: '95vw' }),
    maxHeight: responsive({ 0: '95vh', 2: '95vh' }),
  },
  'xxxl-fixed': {
    variant: 'layout.common.modals.main',
    width: responsive({ 0: '95vw', 2: '95vw' }),
    height: responsive({ 0: '95vh', 2: '95vh' }),
  },
  flex: {
    variant: 'layout.common.modals.main',
    maxWidth: '95vw',
    maxHeight: '95vh',
    '.modal__content': {
      p: spacing(2),
      overflow: 'auto',
    },
  },
  cal: {
    variant: 'layout.common.modals.sm',
    width: '400px',
    maxWidth: '400px',
    '.react-calendar': {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
    },
    '.react-calendar__navigation': {
      display: 'flex',
    },
    abbr: {
      textDecoration: 'none',
    },
    button: {
      backgroundColor: 'palette.background.paper',
      border: '1px solid #e1e1e1',
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: '#ebebeb',
      },
    },
  },
  editGrid: {
    variant: 'layout.common.modals.main',
    width: 'root',
    maxHeight: '90vh',
    '&.modal__variantWrapper': {
      width: 'fit-content !important',
      height: 'fit-content !important',
      resize: 'none',
    },
    '&.modal__main': {
      resize: 'both',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    '.modal__content': {
      resize: 'none',
      overflowX: 'hidden',
    },
  },
  fileModal: {
    variant: 'layout.common.modals.main',
    width: '750px',
    maxHeight: '97vh',
    maxWidth: '95vw',
  },
  /* PREPEND HERE */
};
